module.exports = __webpack_public_path__ + "static/media/index-video-heart.78bab000.png";